<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-radio-group
        v-model="searchCondition.status"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="wait">待办({{ waitNum }})</el-radio-button>
        <el-radio-button label="complete"
          >已完成({{ completeNum }})</el-radio-button
        >
        <el-radio-button label="success"
          >转化成功({{ successNum }})</el-radio-button
        >
        <el-radio-button label="timeOut"> 逾期 ({{ outNum }})</el-radio-button>
        <el-radio-button label="all">全部({{ totalNum }})</el-radio-button>
      </el-radio-group>
      <div>
        <el-input
          placeholder="请输入姓名或者电话"
          v-model="searchCondition.keyWords"
          class="mr10"
          size="small"
          style="width:300px"
          clearable
        >
          <el-select
            v-model="searchCondition.queryType"
            slot="prepend"
            size="small"
            style="width:100px"
            placeholder="请选择"
          >
            <el-option label="会员" value="member"></el-option>
            <el-option label="责任人" value="guider"></el-option>
            <el-option label="任务名称" value="taskName"></el-option>
          </el-select>
        </el-input>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择任务开始时间筛选"
          end-placeholder="请选择任务结束时间筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出列表</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="责任人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="账号所属机构"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="责任人电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="服务客户"
          prop="name"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="客户电话"
          prop="mobile"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="taskName"
          label="任务名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startDates"
          label="任务时间"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.startDate }}至{{ scope.row.endDate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="任务完成时间"
          v-if="searchCondition.status === 'complete'"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="任务状态"
        >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'wait'">待办</div>
          <div v-else-if="scope.row.status === 'complete'">已完成</div>
          <div v-else-if="scope.row.status === 'success'">转化成功</div>
          <div v-else-if="scope.row.status === 'timeOut'">逾期</div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="转化时间"
          v-if="searchCondition.status === 'success'"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="转化订单号"
          v-if="searchCondition.status === 'success'"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      searchCondition: {
        status: "wait",
        queryType: "member",
        keyWords: "",
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      completeNum: 0,
      outNum: 0,
      totalNum: 0,
      waitNum: 0,
      successNum: 0,
      resetForm: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    if(this.$route.query.queryType){
      this.searchCondition.queryType = this.$route.query.queryType;
    }
    if(this.$route.query.taskName){
      this.searchCondition.keyWords = this.$route.query.taskName;
    }
  },
  mounted() {
    this.queryList();
  },
  methods: {
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res;
            list.forEach(v => {
              v.startDates = v.startDate + "至" + v.endDate;
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "活动列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    switchTab() {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 9999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.status =
        searchCondition.status === "all" ? "" : searchCondition.status;
      searchCondition.startDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryTaskSummaryAllList",
        params
      );

      const { records } = result.pageList;
      return records;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.status =
        searchCondition.status === "all" ? "" : searchCondition.status;
      searchCondition.startDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryTaskSummaryList",
        params
      );
      const { completeNum, outNum, pageList, totalNum, waitNum, successNum } = result;
      this.completeNum = completeNum;
      this.outNum = outNum;
      this.totalNum = totalNum;
      this.waitNum = waitNum;
      this.successNum = successNum;
      const { records, total } = pageList;
      this.list = records;
      this.total = total;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
